import type { Block, BlockWithKnowledge } from '@types'
import axios from 'axios'

import env from '../environments'

export async function createBlock(applicationId: string, index: number, blockName: string) {
	const response = await axios.post(`${env.apiUrl}/blocks`, { applicationId, index, title: blockName })

	return (response.data as {block: Block}).block
}

export async function updateBlock(blockId: string, block: Partial<BlockWithKnowledge>) {
	// Remove knowledge property to avoid EntityPropertyNotFoundError
	const { knowledge, ...blockWithoutKnowledge } = block

	const response = await axios.put(`${env.apiUrl}/blocks/${blockId}`, { block: blockWithoutKnowledge })

	return (response.data as {block: Block}).block
}

export async function addBlockKnowledge(blockId: string, knowledgeId: string, type: 'brain' | 'step' | 'block') {
	await axios.post(`${env.apiUrl}/blocks/${blockId}/blocksKnowledge/${knowledgeId}`, { type })
}

export async function deleteBlockKnowledge(blockId: string, knowledgeId: string, type: 'brain' | 'step' | 'block') {
	await axios.delete(`${env.apiUrl}/blocks/${blockId}/blocksKnowledge/${knowledgeId}`, { data: { type } })
}

export async function deleteBlock(blockId: string) {
	await axios.delete(`${env.apiUrl}/blocks/${blockId}`)
}

export async function addBlockParent(blockId: string, parentId: string) {
	await axios.post(`${env.apiUrl}/blocks/${blockId}/parents/${parentId}`)
}

export async function deleteBlockParent(blockId: string, parentId: string) {
	await axios.delete(`${env.apiUrl}/blocks/${blockId}/parents/${parentId}`)
}

export async function getBlockParentsIds(blockId: string) {
	const response = await axios.get(`${env.apiUrl}/blocks/${blockId}/parents`)

	return (response.data as {blockParents: Array<{parentId: string}>}).blockParents.map(bp => bp.parentId)
}
